
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 23 23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E3E8E9","fill-rule":"evenodd","d":"M17.557 9.059l-5.965 5.965-1.45 1.45a.303.303 0 01-.485 0l-1.451-1.45-2.58-2.58a.303.303 0 010-.484l1.451-1.452a.303.303 0 01.484 0l2.419 2.419 5.804-5.804a.303.303 0 01.484 0l1.451 1.451a.593.593 0 01-.161.485h-.001zM11.615.893c2.01 0 3.868.502 5.578 1.506a10.422 10.422 0 013.912 3.913 10.814 10.814 0 011.507 5.577c0 2.01-.502 3.869-1.507 5.578a10.422 10.422 0 01-3.912 3.913 10.815 10.815 0 01-5.578 1.507c-2.009 0-3.868-.503-5.578-1.507a10.62 10.62 0 01-3.912-3.94 10.767 10.767 0 01-1.507-5.55c0-1.992.502-3.842 1.507-5.552A10.823 10.823 0 016.064 2.4 10.767 10.767 0 0111.615.893z","clip-rule":"evenodd"}})])
          )
        }
      }
    